import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const IceHockeyIcon = observer('IceHockeyIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M22.031 19.492C22.0305 20.7028 19.7276 21.9998 16.2995 21.9998C15.3336 22.0072 14.3703 21.892 13.4333 21.6571V20.5662C13.4332 20.3685 13.2727 20.2079 13.0749 20.2078C12.8771 20.2078 12.7167 20.3685 12.7165 20.5662V21.4325C12.4715 21.3445 12.2319 21.2407 11.9997 21.1229V19.492C11.9997 19.2943 11.84 19.1339 11.6423 19.1336C11.4444 19.1336 11.2839 19.2942 11.2839 19.492V20.6698C10.8802 20.405 10.6168 19.9722 10.5671 19.492V17.0457C11.6286 18.0808 13.7706 18.7752 16.2995 18.7752C18.8284 18.7752 20.9695 18.0807 22.031 17.0457V19.492ZM16.2995 13.0428C19.465 13.0429 22.0307 14.1657 22.031 15.5506C22.031 16.9356 19.4652 18.0584 16.2995 18.0584C13.1337 18.0584 10.5671 16.9357 10.5671 15.5506C10.5674 14.1657 13.1339 13.0428 16.2995 13.0428ZM3.26535 2.04183C3.38275 1.96598 3.53932 1.99594 3.61984 2.11019L9.5632 10.3719C9.68451 10.5225 9.91305 10.5726 10.073 10.4491L12.6452 8.47835L16.9724 5.16585C17.0898 5.0713 17.2405 5.02808 17.3904 5.04476C17.5402 5.06145 17.6775 5.13668 17.7712 5.25472L18.028 5.57699C17.7108 5.63032 17.4093 5.75357 17.1452 5.93734L8.84055 12.2909C8.68319 12.4115 8.65354 12.6364 8.77414 12.7938C8.89485 12.9512 9.11968 12.9809 9.27707 12.8602L17.5622 6.52035C17.8671 6.28299 18.2711 6.2152 18.6364 6.34066L21.1599 9.49593C21.2645 9.62681 21.3066 9.79716 21.2751 9.96175C21.2447 10.124 21.1444 10.2644 21.0007 10.3455L17.4489 12.3787C17.0762 12.3465 16.6934 12.326 16.2995 12.326C12.6834 12.326 9.85053 13.7426 9.85031 15.5506V16.2547C9.70054 16.2447 9.5517 16.2193 9.40695 16.1795C8.81135 16.0194 8.30417 15.6283 7.9968 15.0936C7.97639 15.0528 7.95107 15.0034 7.9382 14.9813L1.99582 3.14339C1.93641 3.02312 1.97655 2.87733 2.08859 2.80355L3.26535 2.04183Z'
                fill='fill'
            />
        </SvgElement>
    );
});
